export default "__VITE_ASSET__B4l$3kSD__"